import axios from 'axios';
import { authHeader } from './authservice/auth-header';

const BASE_API = process.env.VUE_APP_BASE_API_URL;
const API_URL = process.env.VUE_APP_BASE_API_URL_OSINT;

class EducationService {
    SearchNamaMahasiwa(data) {
        return axios.post(API_URL + 'pddikti/search-mhs', data, { headers: authHeader() });
    }
    getMahasiwa(data) {
        return axios.post(API_URL + 'pddikti/detail_mhs', data, { headers: authHeader() });
    }

    SaveCareer(data) {
        return axios.post(BASE_API + 'linkedin', data, { headers: authHeader() });
    }

    getCareer(id) {
        return axios.get(BASE_API + 'linkedin/'+id, { headers: authHeader() });
    }
    
    getEducation(id) {
        return axios.get(BASE_API + 'education/'+id, { headers: authHeader() });
    }

    SaveEducation(data) {
        return axios.post(BASE_API + 'education', data, { headers: authHeader() });
    }

    deleteEducation(id) {
        return axios.delete(BASE_API + 'education/'+id, { headers: authHeader() });
    }

    deleteCareer(id) {
        return axios.delete(BASE_API + 'linkedin/'+id, { headers: authHeader() });
    }

}

export default new EducationService();
